import React from 'react';
import './ContactSection.css';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaThumbsUp, FaLightbulb, FaMedal, FaMapMarkerAlt, FaHandshake } from 'react-icons/fa';

function ContactSection({ isHomePage }) {
	return (
		<section className={isHomePage ? "contact-section home" : "contact-section-standalone"}>
			<div className="contact-section-container">
				<h1 className="contact-title">Aditya Electro Projects</h1>
				<div className="contact-info-container">
					<div className="contact-text-cont">
						<p>Aditya Electro Projects is committed to and understand that the safety and health of our employee is one of the utmost important elements. We are committed to provide and maintain a safe and healthy work environment and promote safe work practices in its entire operational and/or work execution process.</p>
            
						<p>We shall generate continual efforts for the improvement and prevention of occupational accidents, through setting of measurable means by adopting benchmarks against the established organizational goals, objectives and targets to review and monitor the performance periodically in order to ensure the effectiveness of the safety team.</p>
					</div>
					<div className="contact-details-cont">
						<div className="contact-details">
							<p>Ashok Srivastava</p>
							<div className="phone cont">
								<i className="fas fa-phone-alt"></i>
								<a href="tel:08744002491">8744002491</a>
							</div>
							<div className="email cont">
								<i className="far fa-envelope"></i>
								<a href="mailto:adityaelectroprojects@gmail.com">adityaelectroprojects@gmail.com</a>
							</div>
							<div className="social-media-links-container">
								<Link
									className='social-link'
									to={'//www.linkedin.com'}
									target='_blank'
									aria-label='LinkedIn'
								>
									<FaLinkedin />
								</Link>
							</div>
						</div>
						{/* <img className="contact-logo" src="/images/logo1.png" alt="logo" /> */}
					</div>
				</div>
				<div className={"contact-standalone-footer" + (isHomePage ? " contact-footer-on-home" : "")}>
						<div className="footer-left">
							<div className="footer-features">
								<div className="feature-item">
									<FaThumbsUp className="feature-icon" />
									<h4>12 Month Guarantee</h4>
								</div>
								<div className="feature-item">
									<FaLightbulb className="feature-icon" />
									<h4>NICEIC Approved</h4>
								</div>
								<div className="feature-item">
									<FaMedal className="feature-icon" />
									<h4>Fully Insured</h4>
								</div>
								<div className="feature-item">
									<FaMapMarkerAlt className="feature-icon" />
									<h4>Local Electricians</h4>
								</div>
								<div className="feature-item">
									<FaHandshake className="feature-icon" />
									<h4>Our Platinum promises</h4>
								</div>
							</div>
						</div>
				</div>
				
			</div>
		</section>
	);
}

export default ContactSection;

